module.exports = __webpack_public_path__ + "fab1b6b1bb9a4bb26bedac78c5c0ff0c.jpg";